{
	"columns":[
		{
			"header_id": "participantPPLId",
			"header_label": "Participant PPL ID",
			"jsonpath":  "participantPPLId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "n"
		},
		{
			"header_id": "participantName",
			"header_label": "Participant Name",
			"jsonpath":  "participantName" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "n"
		},
        {
			"header_id": "serviceDate",
			"header_label": "Service Date",
			"jsonpath":  "serviceDate" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "n"
		},
		{
			"header_id": "serviceCode",
			"header_label": "Service Code",
			"jsonpath":  "serviceCode" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "n"
		},
		{
			"header_id": "submissionDate",
			"header_label": "Submission Date",
			"jsonpath":  "submissionDate" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "n"
		},
        {
			"header_id": "timeIn",
			"header_label": "Time In",
			"jsonpath":  "timeIn" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "n"
		},
        {
			"header_id": "timeOut",
			"header_label": "Time Out",
			"jsonpath":  "timeOut" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "n"
		},
        {
			"header_id": "billedUnitsInHrs",
			"header_label": "Billed Hours",
			"jsonpath":  "billedUnitsInHrs" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "n"
		},
        {
			"header_id": "serviceRate",
			"header_label": "Service Rate",
			"jsonpath":  "serviceRate" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "n"
		},
		{
			"header_id": "billableRate",
			"header_label": "Billable Rate",
			"jsonpath":  "billableRate" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "n"
		},
		{
			"header_id": "businessStatusText",
			"header_label": "Business Status",
			"jsonpath":  "businessStatusText" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "n"
		},
		{
			"header_id": "processingStatusText",
			"header_label": "Processing Status",
			"jsonpath":  "processingStatusText" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "n"
		},
		{
			"header_id": "timesheetLineId",
			"header_label": "Timesheet Detail ID",
			"jsonpath":  "timesheetLineId" ,
			"isDisplayedAtHeader": "n",
			"isSearchable": "n"
		}
    ],
	"buttons": [],
    "apiDetails": "providerTimesheetTimeOffView.json",
	"pageName": "staffTimeOffEntry",
	"orderByColumn": ["createdDate"],
	"orderBy": ["desc"]
}
